// B3.6 — step callout chrome (Next + Cancel always visible).

import { FIREFLY_TOUR_CALLOUT_Z } from "@/lib/firefly/fireflyTourLayerZIndex";

export type FireflyTourStepCalloutProps = {
  title: string | null;
  body: string | null;
  stepIndex: number;
  stepCount: number;
  canAdvance: boolean;
  waitForUserAction: boolean;
  describeOnly: boolean;
  onNext: () => void;
  onCancel: () => void;
};

export function FireflyTourStepCallout(props: FireflyTourStepCalloutProps) {
  const {
    title,
    body,
    stepIndex,
    stepCount,
    canAdvance,
    waitForUserAction,
    describeOnly,
    onNext,
    onCancel,
  } = props;

  if (!body) return null;

  const advanceHint = waitForUserAction
    ? "Tap the highlighted control to continue."
    : describeOnly
      ? "This step is describe-only — you perform the action yourself."
      : null;

  return (
    <div
      role="dialog"
      aria-label="Firefly guided tour step"
      className="fixed bottom-6 left-1/2 w-[min(22rem,calc(100vw-2rem))] -translate-x-1/2 rounded-2xl border border-emerald-400/60 bg-white p-4 shadow-xl dark:border-emerald-500/40 dark:bg-zinc-900"
      style={{ zIndex: FIREFLY_TOUR_CALLOUT_Z }}
    >
      <div className="mb-1 flex items-center justify-between gap-2">
        <span className="text-[10px] font-semibold uppercase tracking-wide text-emerald-700 dark:text-emerald-300">
          Tour · {stepIndex + 1} / {stepCount}
        </span>
        <button
          type="button"
          onClick={onCancel}
          className="text-[11px] font-medium text-gray-500 hover:text-gray-800 dark:text-zinc-400 dark:hover:text-zinc-200"
        >
          Dismiss
        </button>
      </div>
      {title ? (
        <h4 className="text-sm font-semibold text-gray-900 dark:text-zinc-100">{title}</h4>
      ) : null}
      <p className="mt-1 text-xs leading-relaxed text-gray-700 dark:text-zinc-300">{body}</p>
      {advanceHint ? (
        <p className="mt-2 text-[11px] text-gray-500 dark:text-zinc-400">{advanceHint}</p>
      ) : null}
      <div className="mt-3 flex justify-end gap-2">
        <button
          type="button"
          onClick={onCancel}
          className="rounded-lg border border-gray-300 px-3 py-1.5 text-xs font-medium text-gray-700 dark:border-zinc-600 dark:text-zinc-200"
        >
          Cancel tour
        </button>
        {canAdvance ? (
          <button
            type="button"
            onClick={onNext}
            className="rounded-lg bg-emerald-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-emerald-700"
          >
            Next
          </button>
        ) : null}
      </div>
    </div>
  );
}
